import { insertAfter } from "../helpers/elements";
var $ = require("jquery");
var ToggleBoxLink = /** @class */ (function () {
    function ToggleBoxLink(element) {
        this.element = element;
        this.initEvents();
        this.contentBox = this.element.parentElement.querySelector('.ac-toggle-box-contents');
        if (!this.contentBox) {
            this.createContenBox();
        }
    }
    ToggleBoxLink.prototype.isAjax = function () {
        return parseInt(this.element.dataset.ajaxPopulate) === 1;
    };
    ToggleBoxLink.prototype.isInited = function () {
        return this.element.dataset.toggleBoxInit;
    };
    ToggleBoxLink.prototype.createContenBox = function () {
        var contentBox = document.createElement('div');
        contentBox.classList.add('ac-toggle-box-contents');
        insertAfter(contentBox, this.element);
        this.contentBox = contentBox;
        return this.contentBox;
    };
    ToggleBoxLink.prototype.initEvents = function () {
        var _this = this;
        if (this.isInited()) {
            return;
        }
        this.element.addEventListener('click', function (e) {
            e.preventDefault();
            if (_this.isAjax() && !_this.hasContent()) {
                _this.manageAjaxValue();
            }
            _this.toggleContentBox();
        });
        this.element.dataset.toggleBoxInit = 'true';
    };
    ToggleBoxLink.prototype.hasContent = function () {
        return this.getContentBox().innerHTML.length > 0;
    };
    ToggleBoxLink.prototype.setContent = function (content) {
        this.getContentBox().innerHTML = content;
    };
    ToggleBoxLink.prototype.getContentBox = function () {
        if (!this.contentBox) {
            return this.createContenBox();
        }
        return this.contentBox;
    };
    ToggleBoxLink.prototype.setLabel = function (open) {
        var label = this.element.dataset.label;
        if (open && this.element.dataset.labelClose) {
            label = this.element.dataset.labelClose;
        }
        this.element.innerHTML = label + '<span class="spinner"></span>';
    };
    ToggleBoxLink.prototype.toggleContentBox = function () {
        if (this.getContentBox().classList.contains('-open')) {
            this.getContentBox().classList.remove('-open');
            this.setLabel(false);
        }
        else {
            this.getContentBox().classList.add('-open');
            this.setLabel(true);
        }
    };
    ToggleBoxLink.prototype.manageAjaxValue = function () {
        var _this = this;
        this.element.classList.add('loading');
        this.retrieveAjaxValue().done(function (response) {
            _this.setContent(response);
            $(_this.element.parentElement).trigger('ajax_column_value_ready');
            AdminColumns.Tooltips.init();
        }).always(function () {
            _this.element.classList.remove('loading');
        });
    };
    ToggleBoxLink.prototype.retrieveAjaxValue = function () {
        return $.ajax({
            url: ajaxurl,
            method: 'POST',
            data: {
                action: 'ac_get_column_value',
                list_screen: AC.list_screen,
                layout: AC.layout,
                column: this.element.dataset.column,
                pk: this.element.dataset.itemId,
                _ajax_nonce: AC.ajax_nonce
            }
        });
    };
    return ToggleBoxLink;
}());
export default ToggleBoxLink;
